import React, { useState, useEffect } from "react";
import { useViewport } from 'components/general/useViewPort'
import Label from "components/general/Label"
import { SplitResults, getConfigData, getsplitByPty } from "./TableExpanded";
import Competitor from "components/presentation/Competitor";
import Noc from "components/presentation/Noc";
import { arraysEqual } from "helpers/utils";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";



export const Currents = (props) => {
    const { data, cumulativeData, currents } = props;
    const { breakPoint } = useViewport()
    if (!Array.isArray(currents) || currents.length === 0) return <></>;

    const adjustByTotalTime = 0;
    const { gates, splits, totalGates, colsExtendedVisible, cumulatedColsExtendedVisible } = getConfigData(data?.config?.extendedConfig, adjustByTotalTime)
    const showNavBar = breakPoint === "sm" || breakPoint === "xs"

    const currentsOut = currents.map(current => {
        const res = data?.results?.items?.find(item => item?.participant?.code === current);
        const cumRes = cumulativeData?.cumulativeResults?.results?.find(item => item?.participant?.code === current);
        if (res) return (<CurrentResults
            res={res}
            cumRes={cumRes}
            gates={gates}
            splits={splits}
            totalGates={totalGates}
            colsExtendedVisible={colsExtendedVisible}
            cumulatedColsExtendedVisible={cumulatedColsExtendedVisible}
            key={current}
            adjustByTotalTime={adjustByTotalTime}
            showNavBar={showNavBar} />)
    })

    return <>
        <h4><Label data={currents && currents.length > 1 ? 'LabelCurrentCompetitors' : 'LabelCurrentCompetitor'} /></h4>
        {currentsOut}
    </>

}

const CurrentResults = React.memo((props) => {
    const { gates, splits, res, cumRes, totalGates, colsExtendedVisible, cumulatedColsExtendedVisible, adjustByTotalTime, showNavBar } = props;
    const { mirs_rsc } = useUrlFriendlyToParameters()
    const isFinals = !mirs_rsc?.includes("HEAT")
    const [columnindex, setColumnIndex] = useState(getsplitByPty(cumulatedColsExtendedVisible, res));
    const [displayArr, setDisplayArr] = useState(['d-table-cell'], ...Array(totalGates + adjustByTotalTime).fill('d-table-cell'));

    useEffect(() => {
        let array_ = ['d-table-cell']
        if (!showNavBar) {
            array_ = [...array_, ...Array(Number(totalGates + adjustByTotalTime)).fill('d-table-cell')]
        } else {
            colsExtendedVisible.forEach((item, i) => {
                if (i === columnindex - 1) {
                    array_ = [...array_, ...Array(Number(item)).fill('d-table-cell')]
                } else {
                    array_ = [...array_, ...Array(Number(item)).fill('d-none')]
                }
            })
        }
        setDisplayArr(array_);
    }, [showNavBar, columnindex])

    useEffect(() => {
        setColumnIndex(getsplitByPty(cumulatedColsExtendedVisible, res));
    }, [res])



    const gateNumbers = <>{
        gates.map(gate => (<td className={`border text-center fw-bold ${displayArr[Number(gate?.pos)]}`} key={gate?.pos}>{gate?.pos}</td>))
    }</>

    const gatePenalties = <>{
        gates.map(gate => {
            const pty = res?.extendedResults?.find(er => er?.er_code === 'GATE_PTY' && er?.er_pos === gate?.pos);
            const colorBackground = pty?.er_value === '-' ? 'bg-success' : pty?.er_value === '2' ? 'bg-warning' : pty?.er_value === '50' ? 'bg-danger' : 'bg-white';
            return (<td className={`border text-center bg-success ${colorBackground} ${displayArr[Number(gate?.pos)]}`} key={gate?.pos}>{pty?.er_value ? pty?.er_value : ''}</td>);
        })
    }</>

    let colSpan = 1;
    const splitTimes = <>{
        gates.map((gate, colIndex) => {
            let split = splits?.find(splt => splt?.value === gate?.pos);
            if (split) {
                const splitLabel = <Label data={split?.extension?.find(e => e?.code === 'NAME')?.value} />;
                const time = res?.extendedResults?.find(er => er?.er_code === 'INTERMEDIATE' && er?.er_pos === split?.pos);
                const out = (<td colSpan={colSpan} className={`text-center border-end fw-bold ${displayArr[colIndex + 1]}`} key={split?.pos}>{splitLabel}: {time?.er_value ? time?.er_value : ''}</td>);
                colSpan = 1;
                return out;
            } else if (gate?.pos == totalGates) {
                return (<td colSpan={colSpan} className={`text-center ${displayArr[colIndex + 1]}`} key="F"></td>);
            } else {
                colSpan++;
            }
        })
    }</>


    const xl = (<>

        <table className="table">
            <thead>
                <tr>
                    <th className="w-5 text-end"><Label data={'LabelStartOrderN'} /></th>
                    {isFinals && <th className="w-5 text-end"><Label data={'HeaderBibNoR'} /></th>}
                    <th colSpan="2" className="text-start"><Label data={'HeaderName'} /></th>
                    <th className="w-10 text-end"><Label data={'HeaderTime'} /></th>
                    <th className="w-10 text-end"><Label data={'HeaderPenaltySecondsR'} /></th>
                    <th className="w-10 text-end"><Label data={'HeaderTotal'} /></th>
                    <th className="w-10 text-end"><Label data={'HeaderRank'} /></th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td className="text-end">{res?.startOrder}</td>
                    {isFinals && <td className="w-5 text-end">{res?.bib}</td>}
                    <td className="w-5 text-end"><Noc {...res?.participant?.organisation} /></td>
                    <td><Competitor {...res?.participant} hideNoc={true} hidePicture={true} /></td>
                    <td className="text-end">{res?.extendedResults?.find(er => er?.er_code === 'INTERMEDIATE' && er?.er_pos === 'F')?.er_value2}</td>
                    <td className="text-end">{res?.pty}</td>
                    <td className="text-end">{res?.resultData}</td>
                    <td className="text-end">{res?.resultRank}</td>
                </tr>
                <tr>
                    <td colSpan={isFinals ? '8' : '7'} >
                        <SplitResults
                            gateNumbers={gateNumbers}
                            gatePenalties={gatePenalties}
                            splitTimes={splitTimes}
                            pty={res?.pty}
                            adjustByTotalTime={adjustByTotalTime}
                            totalGates={totalGates}
                            colsExtendedVisible={colsExtendedVisible}
                            columnindex={columnindex}
                            setColumnIndex={setColumnIndex}
                            displayArr={displayArr}
                            showNavBar={showNavBar} />

                    </td>
                </tr>
            </tbody>
        </table>

    </>)

    const xs = (<>
        <table className="table">
            <tbody>
                <tr>
                    <td rowSpan={4} className="w-5 text-end align-text-center border-bottom-0 fw-bold">{isFinals ? res?.bib : res?.startOrder}  </td>
                    <td rowSpan={4} className="w-5 text-end align-text-center border-bottom-0 fw-bold"><Noc {...res?.participant?.organisation} /></td>
                    <td rowSpan={4} className="align-text-center border-bottom-0 fw-bold"><Competitor {...res?.participant} hideNoc={true} hidePicture={true} /></td>
                    <td className="text-start border-bottom-0 fw-bold"><Label data={'HeaderTime'} />: {res?.extendedResults?.find(er => er?.er_code === 'INTERMEDIATE' && er?.er_pos === 'F')?.er_value2}</td>
                </tr>
                <tr>
                    <td className="text-start border-bottom-0 fw-bold"><Label data={'HeaderPenaltySecondsR'} />: {res?.pty}</td>
                </tr>
                <tr>
                    <td className="text-start border-bottom-0 fw-bold"><Label data={'HeaderTotal'} />: {res?.resultData}</td>
                </tr>
                <tr>
                    <td className="text-start border-bottom-0 fw-bold"><Label data={'LabelRank'} />: {res?.resultRank}</td>
                </tr>
                <tr>
                    <td colSpan={4} >
                        <SplitResults
                            gateNumbers={gateNumbers}
                            gatePenalties={gatePenalties}
                            splitTimes={splitTimes}
                            pty={res?.pty}
                            adjustByTotalTime={adjustByTotalTime}
                            totalGates={totalGates}
                            colsExtendedVisible={colsExtendedVisible}
                            columnindex={columnindex}
                            setColumnIndex={setColumnIndex}
                            displayArr={displayArr}
                            showNavBar={showNavBar} />

                    </td>
                </tr>
            </tbody>
        </table>

    </>)

    return showNavBar ? xs : xl;

}, (prevProps, nextProps) => {
    //Si retornamos true:  No se renderiza
    //Si retornamos false: Si se renderiza
    //renderizamos cuando un dato de los visibles cambia
    //return false;
    return arraysEqual(prevProps?.res?.extendedResults, nextProps?.res?.extendedResults) && prevProps?.showNavBar === nextProps?.showNavBar;
}

)


